export class LicenseBundleToUpdate {
  licenseBundleId: string;
  offlineLicenseKey: string;
  offlineLicenseKeyExpirationTime: Date;

  constructor(params: any) {
    this.licenseBundleId = params.licenseBundleId;
    this.offlineLicenseKey = params.offlineLicenseKey;
    this.offlineLicenseKeyExpirationTime = params.offlineLicenseKeyExpirationTime && new Date(params.offlineLicenseKeyExpirationTime);
  }
}
